<template>
  <div class="py-7">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" lg="7" class="mt-4 pr-lg-16" order="12" order-lg="0">
          <div class="white--text mb-4 contact-title">Contato</div>

          <v-form
            @submit="onSubmit"
            :action="this.server + this.$route.fullPath"
            ref="form"
            id="form-contact"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              dense
              name="name"
              v-model="name"
              :rules="nameRules"
              label="Nome"
              required
              outlined
              :dark="true"
            ></v-text-field>

            <v-row>
              <v-col cols="12" md="6" class="pb-0 pb-md-3">
                <v-text-field
                  dense
                  name="email"
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                  outlined
                  :dark="true"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="pt-0 pt-md-3">
                <v-text-field
                  dense
                  name="phone"
                  v-model="phone"
                  :rules="phoneRules"
                  label="Telefone"
                  required
                  outlined
                  v-mask="'(##) ####-####'"
                  :dark="true"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-textarea
              dense
              name="message"
              v-model="message"
              :rules="messageRules"
              label="Mensagem"
              :counter="300"
              required
              outlined
              :dark="true"
            ></v-textarea>

            <v-checkbox
              name="policy_privacy"
              v-model="policy_privacy"
              :rules="[(v) => !!v || 'Você precisa aceitar para continuar.']"
              required
              value="1"
              on-icon="fa fa-check-square"
              off-icon="far fa-square"
              class="policy-privacy mt-0"
              :dark="true"
            >
              <template v-slot:label>
                <div>
                  Eu li e concordo com a
                  <a
                    @click="showPrivacy"
                    class="secondary--text text--lighten-1"
                    >Política de Privacidade</a
                  >.
                </div>
              </template>
            </v-checkbox>

            <v-btn
              color="secondary"
              class="py-4 px-12 mt-4 font-weight-medium btn-contact"
              type="submit"
              depressed
              height="42"
            >
              ENVIAR
            </v-btn>
          </v-form>
        </v-col>

        <v-col
          cols="12"
          lg="5"
          class="mt-4"
          order="0"
          order-lg="12"
          v-if="contact.length"
        >
          <div class="white--text contact-title">Informações</div>

          <div class="d-flex flex-column">
            <div
              v-for="(item, i) in contact"
              :key="i"
              class="d-flex align-center mt-3"
            >
              <div v-if="Array.isArray(item)">
                <v-btn color="secondary" class="mr-2" small icon>
                  <v-icon size="18">{{ item[0].icon }}</v-icon>
                </v-btn>
                <a
                  class="white--text text-decoration-none"
                  v-for="(val, key) in item"
                  :key="key"
                  :href="val.link"
                >
                  {{ (key > 0 ? " / " : "") + val.title }}
                </a>
              </div>
              <div v-else>
                <v-btn
                  :href="item.link"
                  color="secondary"
                  class="mr-2"
                  small
                  icon
                >
                  <v-icon size="18">{{ item.icon }}</v-icon>
                </v-btn>
                <a
                  class="white--text text-decoration-none"
                  :href="item.link"
                  target="_blank"
                >
                  {{ item.title }}
                </a>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      :color="color"
      centered
      v-model="snackbar"
      :timeout="timeout"
      :multi-line="true"
    >
      <v-icon color="white" x-large class="mr-2 check">
        fas fa-check-circle
      </v-icon>
      {{ response }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false" icon>
          <v-icon> fa fa-times </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { getContact } from "../../config";
import { mask } from "vue-the-mask";
import { phoneTest } from "../utils";

export default {
  data: () => ({
    color: "",
    response: "",
    snackbar: false,
    loadingForm: false,
    timeout: 6000,
    valid: true,
    name: "",
    nameRules: [(v) => !!v || "Digite seu nome."],
    email: "",
    emailRules: [
      (v) => !!v || "Digite seu e-mail.",
      (v) => /.+@.+\..+/.test(v) || "Digite um e-mail válido.",
    ],
    phone: "",
    phoneRules: [
      (v) => !!v || "Digite seu telefone.",
      (v) => phoneTest(v) || "Digite um telefone válido",
    ],
    message: "",
    messageRules: [
      (v) => !!v || "Digite sua mensagem.",
      (v) =>
        v.length <= 300 || "Sua mensagem deve conter menos que 300 caracteres",
    ],
    policy_privacy: false,
  }),
  computed: {
    informations() {
      return this.$rest(`informations`).item;
    },
    contact() {
      return getContact(this);
    },
  },
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
    onSubmit(event) {
      const form = document.getElementById("form-contact");

      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        const formData = new FormData(form);
        const action = `${this.server}/rest/email/contact-us`;

        fetch(action, {
          method: "POST",
          body: formData,
        })
          .then((r) => {
            if (r.ok) {
              this.$refs.form.reset();
              this.$refs.form.resetValidation();
              this.snackbar = true;
              this.response =
                "Contato realizado com sucesso! Entraremos em contato em breve.";
              this.color = "primary";
            } else {
              console.log("then");
              this.snackbar = true;
              this.response =
                "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
              this.color = "red accent-2";
            }
          })
          .catch(() => {
            console.log("error");
          })
          .finally(() => {
            this.loadingForm = false;
          });
      }

      event.preventDefault();
    },
  },
  directives: {
    mask,
  },
};
</script>

<style scoped>
.contact-title {
  font-size: 37px;
  font-weight: 400;
  line-height: 55px;
}

.btn-contact {
  font-size: 16px;
}

@media screen and (max-width: 600px) {
  .contact-title {
    font-size: 22px;
    line-height: 26px;
  }
}
</style>
